import React, { useContext } from 'react';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import ArtStage from '../../../ArtStage';
import Details from '../../../DeviationViews/Details';
import TextualContent from '../../../DeviationViews/TextualContent/TextualContent';
import MonetizationBlock from '../../../Sidebar/SidebarBlock/layouts/MonetizationBlock';
import Sidebar from '../../../Sidebar';
import StashBanner from '../../../banners/StashBanner';
import ActionBar from '../../../ActionBar';
import { useIsCurrentUserDeviationAuthor } from '../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { isExtendedDeviationFullyLoaded } from '../../redux/helpers';
import CentralColumn from '../CentralColumn';
import Comments from '../Comments';
import s from './StashPageContent.scss';
const StashPageContent = ({ deviation })=>{
    var _deviation_extended_relatedContent, _deviation_extended;
    const isMobile = useContext(MobileContext);
    const isAuthor = useIsCurrentUserDeviationAuthor(deviation);
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const monetizationBlock = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_relatedContent = _deviation_extended.relatedContent) === null || _deviation_extended_relatedContent === void 0 ? void 0 : _deviation_extended_relatedContent.find((block)=>block.contentType.includes('monetization_') || block.contentType === 'monetization_promotion_adoptable');
    const isRaisingMonetizationBlock = isMobile && isExtendedLoaded && monetizationBlock;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['stage']
    }, /*#__PURE__*/ React.createElement(ArtStage, {
        deviation: deviation
    }), !isMobile && isAuthor && /*#__PURE__*/ React.createElement(StashBanner, {
        className: s['banner']
    }), /*#__PURE__*/ React.createElement(ActionBar, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(CentralColumn, null, /*#__PURE__*/ React.createElement(TextualContent, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(Details, {
        deviation: deviation
    })), isRaisingMonetizationBlock && /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            sectionname: monetizationBlock.contentType
        }
    }, /*#__PURE__*/ React.createElement(MonetizationBlock, {
        block: monetizationBlock,
        deviation: deviation
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['meta']
    }, /*#__PURE__*/ React.createElement(CentralColumn, {
        supportSidebar: true
    }, /*#__PURE__*/ React.createElement(Comments, {
        deviation: deviation,
        className: s['comments']
    }))), /*#__PURE__*/ React.createElement(Sidebar, {
        deviation: deviation,
        className: cn(s['sidebar'], !deviation.isPublished && s['unpublished'])
    }));
};
StashPageContent.displayName = 'StashPageContent';
export default StashPageContent;

//# sourceMappingURL=StashPageContent.js.map